import { useEffect } from "react";

const NativeAd = () => {
  useEffect(() => {
    // Prevent loading the script twice
    if (
      document.querySelector(
        'script[src="https://pl29780663.effectivecpmnetwork.com/e367d1b5757637105af6085f05140b27/invoke.js"]'
      )
    ) {
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://pl29780663.effectivecpmnetwork.com/e367d1b5757637105af6085f05140b27/invoke.js";
    script.async = true;
    script.setAttribute("data-cfasync", "false");

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      id="container-e367d1b5757637105af6085f05140b27"
      style={{
        margin: "25px 0",
        display: "flex",
        justifyContent: "center",
      }}
    />
  );
};

export default NativeAd;